// packages/hooks/src/form-utils.ts
import { APIError, ParseError } from "@virtual-care/client";
var FIELD_LABELS = {
  phoneNumber: { key: "shared.fields.phoneNumber", ar: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641" },
  email: { key: "shared.fields.email", ar: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A" }
};
var API_ERRORS = {
  "api/not-b2b-patient": {
    key: "shared.api.notB2bPatient",
    ar: "\u0647\u0630\u0647 \u0627\u0644\u062E\u062F\u0645\u0629 \u0645\u062A\u0627\u062D\u0629 \u0641\u0642\u0637 \u0644\u0645\u0631\u0636\u0649 \u0627\u0644\u0634\u0631\u0643\u0627\u062A"
  },
  "api/b2b-patient-profile-not-found": {
    key: "shared.api.b2bPatientProfileNotFound",
    ar: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0645\u0644\u0641 \u0627\u0644\u0645\u0631\u064A\u0636\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0625\u062F\u0627\u0631\u0629"
  },
  "api/b2b-usage-limit-exhausted": {
    key: "shared.api.b2bUsageLimitExhausted",
    ar: "\u0644\u0642\u062F \u0627\u0633\u062A\u0646\u0641\u062F\u062A \u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0645\u062A\u0627\u062D\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0627\u0644\u0625\u062F\u0627\u0631\u0629"
  },
  "api/files-not-found": {
    key: "shared.api.filesNotFound",
    ar: "\u0628\u0639\u0636 \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0645\u0631\u0641\u0642\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629"
  },
  "api/no-doctors-available": {
    key: "shared.api.noDoctorsAvailable",
    ar: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0623\u0637\u0628\u0627\u0621 \u0645\u062A\u0627\u062D\u064A\u0646 \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062D\u062F\u062F"
  },
  "api/doctor-not-available": {
    key: "shared.api.doctorNotAvailable",
    ar: "\u0627\u0644\u0637\u0628\u064A\u0628 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0641\u064A \u0627\u0644\u0648\u0642\u062A \u0627\u0644\u0645\u062D\u062F\u062F"
  },
  "api/record-not-found": {
    key: "shared.api.recordNotFound",
    ar: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629"
  },
  "api/validation-failed": {
    key: "shared.api.validationFailed",
    ar: "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u062F\u062E\u0644\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629"
  },
  "api/forbidden": {
    key: "shared.api.forbidden",
    ar: "\u063A\u064A\u0631 \u0645\u0635\u0631\u062D \u0644\u0643 \u0628\u0627\u0644\u0648\u0635\u0648\u0644"
  }
};
var FIREBASE_ERRORS = {
  "auth/network-request-failed": {
    key: "shared.firebase.networkFailed",
    ar: "\u0641\u0634\u0644 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0634\u0628\u0643\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644\u0643 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A"
  },
  "auth/too-many-requests": {
    key: "shared.firebase.tooManyAttempts",
    ar: "\u062A\u0645 \u062D\u0638\u0631 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0633\u0628\u0628 \u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0645\u062A\u0643\u0631\u0631\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0644\u0627\u062D\u0642\u0627\u064B"
  },
  "auth/invalid-phone-number": {
    key: "shared.firebase.invalidPhone",
    ar: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649"
  }
};
var GENERIC = {
  validation: {
    key: "shared.api.validationGeneric",
    ar: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A"
  },
  formValidation: {
    key: "shared.api.formValidation",
    ar: "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u0629 \u0627\u0644\u0646\u0645\u0648\u0630\u062C"
  },
  unexpected: {
    key: "shared.api.genericUnexpected",
    ar: "\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639"
  },
  retryLater: {
    key: "shared.api.retryLater",
    ar: "\u062D\u062F\u062B \u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u062A\u0648\u0642\u0639\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0644\u0627\u062D\u0642\u064B\u0627"
  },
  uniqueConstraint: {
    key: "shared.api.uniqueConstraint",
    arTemplate: "\u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u062F\u062E\u0644\u0629 \u0641\u064A \u062D\u0642\u0644 {{fields}} \u0645\u0633\u062A\u062E\u062F\u0645\u0629 \u0628\u0627\u0644\u0641\u0639\u0644"
  },
  fieldFallback: {
    key: "shared.fields.fallback",
    ar: "\u0627\u0644\u062D\u0642\u0644"
  }
};
function encodeDirective(entry, params) {
  const parts = [`i18n:${entry.key}`];
  if (params) {
    for (const [name, value] of Object.entries(params)) {
      parts.push(`${name}=${value}`);
    }
  }
  return parts.join("|");
}
function encodeFieldParam(entry) {
  return `::${entry.key}:${entry.ar}`;
}
function formIssue(message) {
  return { form: [{ message }] };
}
function errorToFormIssue(error) {
  if (typeof error === "string") {
    return formIssue(error);
  }
  if (error instanceof APIError) {
    const data = error.data;
    if (data.cause.code === "api/validation-failed") {
      return {
        form: Object.entries(data.cause.errors).map(([_key, value]) => ({
          message: value.map((it) => it.message).join(",")
        }))
      };
    }
    if (data.cause.code === "api/unique-constraint-failed") {
      const fields = data.cause.fields ?? [];
      const entries = fields.map(
        (it) => FIELD_LABELS[it] ?? { key: it, ar: it }
      );
      const fieldsParam = entries.length > 0 ? entries.map(encodeFieldParam).join("\u060C ") : encodeFieldParam(GENERIC.fieldFallback);
      return formIssue(
        `i18n:${GENERIC.uniqueConstraint.key}|fields=${fieldsParam}`
      );
    }
    const entry = API_ERRORS[data.cause.code];
    if (entry) return formIssue(encodeDirective(entry));
    return formIssue(data.cause.detail);
  }
  if (error instanceof ParseError) {
    const formErrors = {};
    if (error.data.fieldErrors) {
      if (Array.isArray(error.data.fieldErrors)) {
        formErrors.form = error.data.fieldErrors.map((issue) => ({
          message: issue.message || encodeDirective(GENERIC.validation)
        }));
      } else {
        Object.entries(error.data.fieldErrors).forEach(([field, issues]) => {
          if (issues && issues.length > 0) {
            formErrors[field] = issues.map((issue) => ({
              message: issue.message || encodeDirective(GENERIC.validation)
            }));
          }
        });
      }
    }
    if (error.data.formErrors && Array.isArray(error.data.formErrors) && error.data.formErrors.length > 0) {
      formErrors.form = error.data.formErrors.map((issue) => ({
        message: issue.message || encodeDirective(GENERIC.formValidation)
      }));
    }
    if (Object.keys(formErrors).length === 0) {
      return formIssue(encodeDirective(GENERIC.validation));
    }
    return formErrors;
  }
  if (error && typeof error === "object" && "code" in error) {
    const code = error.code;
    if (typeof code === "string" && FIREBASE_ERRORS[code]) {
      return formIssue(encodeDirective(FIREBASE_ERRORS[code]));
    }
  }
  if (error instanceof Error) {
    return formIssue(error.message);
  }
  return formIssue(encodeDirective(GENERIC.unexpected));
}
function apiErrorToMessage(error) {
  if (error instanceof APIError) {
    const data = error.data;
    const code = data.cause?.code;
    if (code && API_ERRORS[code]) return encodeDirective(API_ERRORS[code]);
    if (data.cause?.detail) return data.cause.detail;
    if (data.error) return data.error;
  }
  if (error instanceof Error && error.message) return error.message;
  return encodeDirective(GENERIC.retryLater);
}

// packages/hooks/src/use-client.ts
import {
  useMutation,
  useMutationState,
  useQuery,
  useQueryClient
} from "@tanstack/react-query";
import { VirtualCare } from "@virtual-care/client";
var client = new VirtualCare({
  baseUrl: ""
});
function useData(endpoint, input, options) {
  return useQuery({
    queryKey: [endpoint, JSON.stringify(input)],
    ...options,
    meta: { endpoint, input },
    queryFn: () => client.request(endpoint, input ?? {})
  });
}
function useAction(endpoint, options) {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationKey: [endpoint],
    mutationFn: async (input, context) => {
      if (options && "mutationFn" in options && options.mutationFn) {
        return options.mutationFn(
          (input2) => client.request(endpoint, input2),
          context
        );
      }
      return await client.request(endpoint, input);
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      for (const endpoint2 of options?.invalidate ?? []) {
        await queryClient.invalidateQueries({
          predicate(query) {
            return query.meta?.endpoint === endpoint2;
          }
        });
      }
      return options?.onSuccess?.(data, variables, data, context);
    }
  });
}
function useActionState(endpoint) {
  return useMutationState({
    filters: {
      predicate(mutation) {
        return mutation.meta?.endpoint === endpoint;
      }
    }
  });
}

// packages/hooks/src/use-earliest-bookable-date.ts
import { addHours } from "date-fns";
import { useMemo } from "react";

// packages/hooks/src/use-settings.tsx
function useSettings() {
  const settings = useData(
    "GET /settings/public",
    {},
    {
      staleTime: Infinity
    }
  );
  return settings.data;
}
function useSetting(name) {
  const settings = useSettings();
  return settings ? settings[name] : void 0;
}
function useSettingValue(name, defaultValue) {
  return useSetting(name)?.value ?? defaultValue;
}

// packages/hooks/src/use-earliest-bookable-date.ts
function useEarliestBookableDate() {
  const value = useSettingValue("minBookingNoticeHours", "24");
  const minBookingNoticeHours = parseInt(value, 10);
  return useMemo(
    () => addHours(/* @__PURE__ */ new Date(), minBookingNoticeHours),
    [minBookingNoticeHours]
  );
}

// packages/hooks/src/use-monthly-availability.ts
import { isSameDay, isSameMonth } from "date-fns";
import { useMemo as useMemo2 } from "react";
import { userStartOfTomorrow } from "@virtual-care/isomorphic";
function useFetchDateForMonth(displayedMonth) {
  return useMemo2(() => {
    return isSameMonth(displayedMonth, /* @__PURE__ */ new Date()) ? userStartOfTomorrow : displayedMonth;
  }, [displayedMonth]);
}
function useMonthlySlots(data, selectedDate) {
  const disabledDates = useMemo2(() => {
    if (!data) return [];
    return data.filter((dayData) => dayData.slots.length === 0).map((dayData) => new Date(dayData.datetime));
  }, [data]);
  const selectedDateSlots = useMemo2(() => {
    if (!selectedDate || !data) return [];
    const selectedDayAvailability = data.find(
      (dayData) => isSameDay(new Date(dayData.datetime), selectedDate)
    );
    return selectedDayAvailability?.slots ?? [];
  }, [data, selectedDate]);
  return { disabledDates, selectedDateSlots };
}
export {
  apiErrorToMessage,
  client,
  errorToFormIssue,
  useAction,
  useActionState,
  useData,
  useEarliestBookableDate,
  useFetchDateForMonth,
  useMonthlySlots,
  useSetting,
  useSettingValue,
  useSettings
};
//# sourceMappingURL=index.js.map
